import {
	deleteTab,
	deletePost,
	getDailyPosts,
	createDailyPost,
} from "./CommonFunc";
import { useQuery } from "../Site/effects";

function DiaryToolbox(props) {
	const query = useQuery();
	const handleDeletePost = () => {
		deletePost(props.currentDiaryPosts[props.selectedPost].ID_NOTE).then(
			(res) => {
				console.log(`Delete res =>`, res);
				getDailyPosts(props.currentDiary.ID, 0, 10).then((posts) => {
					props.setCurrentDiaryPosts(posts);
					props.setSelectedPost(null);
				});
			}
		);
	};
	const handleDeleteTab = () => {
		deleteTab(props.currentDiary?.ID).then(() => {
			props.refreshMenuList();
		});
	};

	const createPostCopy = () => {
		createDailyPost(
			"",
			props.currentDiary.ID,
			props.currentDiaryPosts[props.selectedPost].MNEMO,
			props.currentDiaryPosts[props.selectedPost].CONT_TXT
		).then((result) => {
			getDailyPosts(props.currentDiary.ID, 0, 10).then((posts) => {
				props.setCurrentDiaryPosts(posts);
				document.getElementById("scrollableContentColumn")?.scrollTo(0, 0);
			});
		});
		props.setSelectedPost(null);
	};
	const visibility = props.currentDiary?.TAB_MNEMO ? true : false;
	return (
		<div className='action-panel'>
			{props.isAdmin ? null : (
				<>
					{props.currentDiary?.TAB_MNEMO ? (
						<>
							<div className='action-panel-title'>Запись</div>
							<div
								className='button-action action'
								onClick={() => props.setOpenAddPost(true)}
							>
								Добавить
							</div>
						</>
					) : null}
					{typeof props.selectedPost === "number" ? (
						<>
							<div
								className='button-action action'
								onClick={() => {
									createPostCopy();
								}}
							>
								Добавить копию
							</div>
							<div
								className='button-action action edit'
								onClick={() => props.setOpenEditPost(true)}
							>
								Редактировать
							</div>
							<div className='button-action delete' onClick={handleDeletePost}>
								Удалить
							</div>
						</>
					) : null}
				</>
			)}
			{props.isAdmin ? (
				<>
					<div className='action-panel-title'>
						{query.get("isNew") === 1 ||
						query.get("isNew") === undefined ||
						query.get("isNew") === null
							? `Дневник`
							: `Вкладка`}
					</div>
					<div
						className='button-action action'
						onClick={() => props.setOpenAddDiary(true)}
					>
						Добавить
					</div>
					{props.currentDiary?.TAB_MNEMO ? (
						<div
							className='button-action action'
							onClick={() => props.setOpenEditTab(true)}
						>
							Переименовать
						</div>
					) : null}

					<div className='button-action delete' onClick={handleDeleteTab}>
						Удалить
					</div>
				</>
			) : null}
		</div>
	);
}

export default DiaryToolbox;
